import { render, staticRenderFns } from "./EventCommentWriteComponent.vue?vue&type=template&id=136f2aba&scoped=true"
import script from "./EventCommentWriteComponent.vue?vue&type=script&lang=js"
export * from "./EventCommentWriteComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136f2aba",
  null
  
)

export default component.exports